import styled from "@emotion/styled";
import { COLOR_DARK_RED } from "shared/theme/colors";

export const StyledError = styled.div`
  margin-top: 0.5rem;
  color: ${COLOR_DARK_RED};
  font-size: 0.875rem;
  font-weight: 400;
`;
